var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("\n  "+_vm._s(_vm.step.humanized)+"\n  "),_vm._l((_vm.step.args),function(arg){return _c('Argument',{key:arg.toString(),attrs:{"arg":arg}})}),_c('div',[_c('i',{staticClass:"fas fa-hand-holding"}),_c('b',[_vm._v(" "+_vm._s(_vm.step && _vm.step.returnValue))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }